export type AppThemeName = 'light' | 'dark' | 'blue';

export interface IThemeOption {
  name: AppThemeName;
  label: string;
  swatch: string;
}

export const THEME_OPTIONS: IThemeOption[] = [
  { name: 'light', label: 'Claro', swatch: '#f3f4f6' },
  { name: 'blue', label: 'Azul', swatch: '#0284c7' },
  { name: 'dark', label: 'Escuro', swatch: '#1e3a5f' },
];

// Fundo sólido do menu lateral. 'light' fica null (usa o fundo neutro original do tema).
export const MENU_ACCENT: Record<AppThemeName, string | null> = {
  light: null,
  blue: '#0284c7',
  dark: '#1e3a5f',
};

// Cor dos ícones/avatar/checkbox na tela de login.
export const LOGIN_ACCENT: Record<AppThemeName, string> = {
  light: '#0284c7',
  blue: '#0284c7',
  dark: '#1e3a5f',
};

// Cor do botão "Entrar" na tela de login (tom levemente diferente do acento acima).
export const LOGIN_BUTTON_ACCENT: Record<AppThemeName, { bg: string; hover: string }> = {
  light: { bg: '#0EA5E9', hover: '#0369A1' },
  blue: { bg: '#0EA5E9', hover: '#0369A1' },
  dark: { bg: 'rgba(255, 255, 255, 0.25)', hover: 'rgba(255, 255, 255, 0.35)' },
};
